
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/living-preferences",
      function () {
        return require("private-next-pages/resources/living-preferences.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/living-preferences"])
      });
    }
  